import { render, staticRenderFns } from "./file-attach-v2.vue?vue&type=template&id=3681a196&scoped=true"
import script from "./file-attach-v2.vue?vue&type=script&lang=js"
export * from "./file-attach-v2.vue?vue&type=script&lang=js"
import style0 from "./file-attach-v2.vue?vue&type=style&index=0&id=3681a196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681a196",
  null
  
)

export default component.exports